<template>
    <div class="ci-color w-100 border border-color-light">
        <div class="w-100 h-160px h-lg-200px pa-20 pa-md-28" :style="'background-color:'+ hex +';'">
            <p class="page-text--sm font-weight-bold">
                <span :class="{'color-white' : type == 'dark'}">{{tit}}</span>
            </p>
        </div>
        <div class="pa-20 pa-md-30 py-lg-34 border-top border-color-light helvetica">
            <p class="page-text--sm font-weight-bold mb-8 mb-lg-14">
                PANTONE {{pantone}}
            </p>
            <div class="d-flex">
                <p class="page-text--sm min-w-60px mr-lg-14 color-grey-a">RGB</p>
                <p>{{rgb}}</p>
            </div>
            <div class="d-flex">
                <p class="page-text--sm min-w-60px mr-lg-14 color-grey-a">CMYK</p>
                <p>{{cmyk}}</p>
            </div>
            <div class="d-flex">
                <p class="page-text--sm min-w-60px mr-lg-14 color-grey-a">HEX</p>
                <p>{{hex}}</p>
            </div>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        type : {type :String, default : ""},
        tit : {type :String, default : ""},
        pantone : {type :String, default : ""},
        rgb : {type :String, default : ""},
        cmyk : {type :String, default : ""},
        hex : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>

</style>